import React from 'react';
import { useDispatch } from 'react-redux';
import cx from 'classnames';
import withStyles from "isomorphic-style-loader/withStyles";
import { FormattedMessage, injectIntl } from 'react-intl';
import messages from '../../locale/messages';
import { Button } from 'react-bootstrap';
import { closeHeaderModal, openHeaderModal } from '../../actions/siteadmin/modalActions';
import n from 'quill/dist/quill.snow.css';
import s from '../../styles/customQuillEditor.css'
import bt from '../commonStyle.css';


function SafetyMeasure({ precautionDetails }) {

    const dispatch = useDispatch()
    const handleClick = () => {
        dispatch(closeHeaderModal('safetyMeasureForm'))
        dispatch(openHeaderModal('bookingForm'))
    }
    return (
        <>
            <div className='safetyMeasuresModalContentBox'><div dangerouslySetInnerHTML={{ __html: precautionDetails?.description }} className='ql-editor frontend' /></div>
            <div className={cx('buttonGroupContainer', 'buttonGroupDivider')}>
                <Button onClick={() => dispatch(closeHeaderModal('safetyMeasureForm'))} className={bt.btnSecondary}><FormattedMessage {...messages.cancelButton} /> </Button>
                <Button onClick={handleClick} className={bt.btnPrimary}><FormattedMessage {...messages.proceed} /> </Button>
            </div>
        </>
    )

}

export default injectIntl(withStyles(n, s, bt)(SafetyMeasure));
